/* Inkan theme scripts */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Header: wordmark → stamp ------------------------------------------- */
  function initHeader(root) {
    const header = root.querySelector('[data-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = '1';
    const threshold = parseInt(header.dataset.threshold || '80', 10);
    const bar = header.querySelector('.site-header__bar');

    const update = () => {
      const heroLogo = document.querySelector('[data-hero-logo]');
      header.classList.toggle('site-header--home', !!heroLogo);
      let scrolled;
      if (heroLogo) {
        const rect = heroLogo.getBoundingClientRect();
        scrolled = rect.bottom < bar.getBoundingClientRect().bottom + 8;
      } else {
        scrolled = window.scrollY > threshold;
      }
      if (header.dataset.stampLock === 'true') scrolled = true;
      header.classList.toggle('is-scrolled', scrolled);
    };
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }, { passive: true });
    update();
  }

  /* Object grid: filters + cursor-following title ----------------------- */
  const cursorLabel = document.querySelector('[data-cursor-label]');
  function initGrid(root) {
    root.querySelectorAll('[data-object-grid]').forEach((grid) => {
      if (grid.dataset.ready) return;
      grid.dataset.ready = '1';

      const chips = grid.querySelectorAll('[data-filter]');
      const empty = grid.querySelector('[data-grid-empty]');
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const value = chip.dataset.filter;
          chips.forEach((c) => {
            const on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          let shown = 0;
          const norm = (t) => (t || '').toLowerCase().replace(/s$/, '');
          grid.querySelectorAll('.object-card').forEach((card) => {
            const match = value === 'all' || (value === 'launch' ? card.dataset.launch === 'launch' : norm(card.dataset.type) === norm(value));
            card.hidden = !match;
            if (match) shown++;
          });
          if (empty) empty.hidden = shown > 0;
          grid.querySelectorAll('[data-grid-divider]').forEach((d) => { d.hidden = value !== 'all'; });
        });
      });

      bindCursorLabels(grid);
    });
  }

  function bindCursorLabels(grid) {
    if (!cursorLabel || !canHover || grid.dataset.labelMode !== 'cursor') return;
    grid.addEventListener('pointerover', (e) => {
      const card = e.target.closest('.object-card');
      if (!card || !grid.contains(card)) return;
      cursorLabel.textContent = card.dataset.title;
      cursorLabel.classList.add('is-visible');
    });
    grid.addEventListener('pointermove', (e) => {
      cursorLabel.style.setProperty('--x', e.clientX + 18 + 'px');
      cursorLabel.style.setProperty('--y', e.clientY + 18 + 'px');
    });
    grid.addEventListener('pointerout', (e) => {
      const to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.object-card') : null;
      if (!to || !grid.contains(to)) cursorLabel.classList.remove('is-visible');
    });
  }

  /* Recommendations ------------------------------------------------------ */
  function initRecommendations(root) {
    root.querySelectorAll('[data-recommendations-url]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      fetch(el.dataset.recommendationsUrl)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recommendations-url]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            delete el.dataset.ready;
            el.removeAttribute('data-recommendations-url');
            initGrid(el.parentElement || document);
          }
        })
        .catch(() => {});
    });
  }

  /* Money ---------------------------------------------------------------- */
  function formatMoney(cents, currency) {
    const amount = cents / 100;
    const n = amount.toLocaleString('en', { minimumFractionDigits: amount % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return (currency ? currency + ' ' : '') + n;
  }

  /* Cart count ----------------------------------------------------------- */
  function refreshCartCount() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((n) => {
          n.textContent = cart.item_count;
          if (cart.item_count > 0) n.removeAttribute('data-empty'); else n.setAttribute('data-empty', '');
        });
      })
      .catch(() => {});
  }

  /* Product form ---------------------------------------------------------- */
  function initProduct(root) {
    root.querySelectorAll('[data-product]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';

      const form = section.querySelector('.product-form');
      if (!form) return;
      const idInput = form.querySelector('[data-variant-id]');
      const priceEl = section.querySelector('[data-price]');
      const addBtn = form.querySelector('[data-add-button]');
      const addText = form.querySelector('[data-add-text]');
      const status = form.querySelector('[data-form-status]');
      const variantsEl = section.querySelector('[data-variants-json]');
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || (priceEl ? priceEl.textContent.trim().split(' ')[0] : '');

      const selected = () => Array.from(section.querySelectorAll('[data-option-position]')).map((fs) => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });

      function markAvailability(current) {
        section.querySelectorAll('[data-option-position]').forEach((fs, i) => {
          fs.querySelectorAll('input').forEach((input) => {
            const test = current.slice();
            test[i] = input.value;
            const exists = variants.some((v) => v.available && v.options.every((o, j) => o === test[j]));
            input.classList.toggle('is-unavailable', !exists);
          });
          const nameEl = fs.querySelector('[data-selected-name]');
          if (nameEl) nameEl.textContent = current[i] || '';
        });
      }

      function onChange() {
        const opts = selected();
        const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        markAvailability(opts);
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addText.textContent = 'Unavailable'; }
          return;
        }
        idInput.value = variant.id;
        if (priceEl) {
          let html = formatMoney(variant.price, currency);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += ' <s class="product__compare">' + formatMoney(variant.compare_at_price, currency) + '</s>';
          }
          priceEl.innerHTML = html;
        }
        if (addBtn && addBtn.dataset.launch !== 'later' && !addBtn.dataset.lockedUntilLaunch) {
          addBtn.disabled = !variant.available;
          addText.textContent = variant.available ? addBtn.dataset.label : addBtn.dataset.soldLabel;
        }
        if (variant.featured_media && variant.featured_media.preview_image) {
          // A colour was chosen, so show that colour's photograph. With a 3D
          // model on the product the picture stage is hidden to begin with,
          // and the model does not change colour, so it has to give way here.
          const mStage = section.querySelector('[data-model-stage]');
          const pStage = section.querySelector('[data-image-stage]');
          if (mStage) mStage.hidden = true;
          if (pStage) pStage.hidden = false;
          const img = section.querySelector('.stage-img');
          if (img) { img.srcset = ''; img.src = variant.featured_media.preview_image.src; }
          // Mark the thumbnail for the picture we just moved to, matching on
          // the file name since the thumbnail and the variant ask the image
          // CDN for different widths of the same image.
          const stem = (s) => (s || '').split('?')[0].split('/').pop();
          const want = stem(variant.featured_media.preview_image.src);
          section.querySelectorAll('[data-thumb]').forEach((b) => {
            b.setAttribute('aria-current', stem(b.dataset.src) === want ? 'true' : 'false');
          });
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      section.querySelectorAll('[data-option-position] input').forEach((input) => input.addEventListener('change', onChange));
      if (variants.length) markAvailability(selected());

      const qty = form.querySelector('.qty__input');
      form.querySelectorAll('[data-qty-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const next = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
          qty.value = next;
        });
      });

      form.addEventListener('submit', (e) => {
        if (!window.fetch || e.submitter && e.submitter.closest('.dynamic-checkout')) return;
        e.preventDefault();
        if (!addBtn || !status || addBtn.disabled) return;
        addBtn.disabled = true;
        const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            status.hidden = false;
            if (!ok) {
              status.classList.add('form-status--error');
              status.textContent = data.description || data.message || 'That could not be added.';
              return;
            }
            status.classList.remove('form-status--error');
            const s = window.inkanStrings || {};
             status.innerHTML = (s.added || 'In your bag') + '. <a href="' + root + 'cart">' + (s.view || 'View bag') + '</a>';
            refreshCartCount();
          })
          .catch(() => form.submit())
          .finally(() => { if (addBtn.dataset.launch !== 'later' && !addBtn.dataset.lockedUntilLaunch) addBtn.disabled = false; });
      });

      initStage(section);
    });
  }

  /* 3D model / image stage ------------------------------------------------ */
  function loadModelViewer(cb) {
    if (window.customElements && customElements.get('model-viewer')) return cb();
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {} }, { name: 'model-viewer', version: '1.12', onLoad: (err) => { if (err) fallback(); else cb(); } }]);
    } else {
      fallback();
    }
    function fallback() {
      const s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
      s.onload = cb;
      document.head.appendChild(s);
    }
  }

  function initStage(section) {
    const modelStage = section.querySelector('[data-model-stage]');
    if (modelStage) {
      loadModelViewer(() => {
        const mv = modelStage.querySelector('model-viewer');
        if (!mv) return;
        const range = parseFloat(modelStage.dataset.range || '25');
        const follow = modelStage.dataset.follow === 'true';
        const drag = modelStage.dataset.drag === 'true';
        if (drag) mv.setAttribute('camera-controls', ''); else mv.removeAttribute('camera-controls');
        mv.setAttribute('disable-zoom', '');
        mv.setAttribute('interaction-prompt', 'none');
        mv.setAttribute('touch-action', 'pan-y');
        if (modelStage.dataset.autoRotate === 'true' && !reduceMotion) {
          mv.setAttribute('auto-rotate', '');
          mv.setAttribute('rotation-per-second', '12deg');
          mv.setAttribute('auto-rotate-delay', '0');
        }

        const baseTheta = 0, basePhi = 78;
        let dragging = false;
        let raf = null;
        let target = { t: baseTheta, p: basePhi };
        let current = { t: baseTheta, p: basePhi };

        const tick = () => {
          current.t += (target.t - current.t) * 0.08;
          current.p += (target.p - current.p) * 0.08;
          mv.cameraOrbit = current.t.toFixed(2) + 'deg ' + current.p.toFixed(2) + 'deg auto';
          if (Math.abs(target.t - current.t) > 0.05 || Math.abs(target.p - current.p) > 0.05) raf = requestAnimationFrame(tick);
          else raf = null;
        };
        const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };

        mv.addEventListener('pointerdown', () => { dragging = true; modelStage.classList.add('has-interacted'); });
        window.addEventListener('pointerup', () => {
          if (!dragging) return;
          dragging = false;
          const orbit = mv.getCameraOrbit ? mv.getCameraOrbit() : null;
          if (orbit) {
            current.t = target.t = (orbit.theta * 180) / Math.PI;
            current.p = target.p = (orbit.phi * 180) / Math.PI;
          }
        });

        if (follow && canHover && !reduceMotion && modelStage.dataset.autoRotate !== 'true') {
          let anchorT = baseTheta;
          modelStage.addEventListener('pointerenter', () => { anchorT = current.t; });
          modelStage.addEventListener('pointermove', (e) => {
            if (dragging) return;
            const r = modelStage.getBoundingClientRect();
            const x = (e.clientX - r.left) / r.width - 0.5;
            const y = (e.clientY - r.top) / r.height - 0.5;
            target.t = anchorT + x * range * 2;
            target.p = basePhi + y * Math.min(range, 20);
            kick();
          });
          modelStage.addEventListener('pointerleave', () => {
            if (dragging) return;
            target.p = basePhi;
            kick();
          });
        }
      });
      // No early return here. The thumbnails and the picture stage below have
      // to be wired up even when a model is present — that is the whole point
      // of being able to switch between them.
    }

    const tiltStage = section.querySelector('[data-tilt-stage]');
    if (tiltStage && canHover && !reduceMotion) {
      const el = tiltStage.querySelector('[data-tilt-target]');
      const range = Math.min(parseFloat(tiltStage.dataset.range || '25') / 2, 18);
      tiltStage.addEventListener('pointermove', (e) => {
        const r = tiltStage.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'rotateY(' + (x * range).toFixed(2) + 'deg) rotateX(' + (-y * range).toFixed(2) + 'deg) scale(1.02)';
      });
      tiltStage.addEventListener('pointerleave', () => { el.style.transform = ''; });
    }

    // Switches the stage between the 3D model and a photograph. A thumbnail
    // for a model shows the model; any other thumbnail shows the picture.
    function showStage(section, wantModel) {
      const m = section.querySelector('[data-model-stage]');
      const p = section.querySelector('[data-image-stage]');
      if (m) m.hidden = !wantModel;
      if (p) p.hidden = !!wantModel && !!m;
    }

    section.querySelectorAll('[data-thumb]').forEach((btn, i, all) => {
      const startsOnModel = !!section.querySelector('[data-model-stage]:not([hidden])');
      if (startsOnModel ? btn.dataset.mediaType === 'model' : i === 0) {
        btn.setAttribute('aria-current', 'true');
      }
      btn.addEventListener('click', () => {
        const wantModel = btn.dataset.mediaType === 'model';
        showStage(section, wantModel);
        if (!wantModel) {
          const img = section.querySelector('.stage-img');
          if (img && btn.dataset.src) { img.srcset = ''; img.src = btn.dataset.src; }
        }
        all.forEach((b) => b.setAttribute('aria-current', b === btn ? 'true' : 'false'));
      });
    });
  }

  /* Tabs ----------------------------------------------------------------- */
  function initTabs(root) {
    root.querySelectorAll('[data-tabs]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); n.focus(); select(n); }
        });
      });
    });
  }

  /* Waitlist tag choices ---------------------------------------------------- */
  function initWaitlist(root) {
    root.querySelectorAll('[data-waitlist]').forEach((wrap) => {
      const input = wrap.querySelector('[data-tags-input]');
      if (!input || wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const choices = wrap.querySelectorAll('[data-tag-choice]');
      const sync = () => {
        const tags = [input.dataset.baseTag].concat(Array.from(choices).filter((c) => c.checked).map((c) => c.value)).filter(Boolean);
        input.value = tags.join(',');
      };
      choices.forEach((c) => c.addEventListener('change', sync));
    });
  }

  /* Auto-submitting selects (sort, filters, currency) ---------------------- */
  function initAutosubmit(root) {
    root.querySelectorAll('[data-autosubmit]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      el.addEventListener('change', () => el.form && el.form.submit());
    });
  }

  /* Featured carousel ----------------------------------------------------- */
  function initCarousel(root) {
    root.querySelectorAll('[data-carousel]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = wrap.querySelector('[data-carousel-track]');
      const counter = wrap.querySelector('[data-carousel-index]');
      const slides = track.children;
      const go = (dir) => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        const next = (i + dir + slides.length) % slides.length;
        track.scrollTo({ left: next * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      const prev = wrap.querySelector('[data-carousel-prev]');
      const next = wrap.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      track.addEventListener('scroll', () => {
        if (counter) counter.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
    });
  }

  /* Collection tile videos on hover ---------------------------------------- */
  function initTiles(root) {
    root.querySelectorAll('[data-tile]').forEach((tile) => {
      const video = tile.querySelector('video');
      if (!video || tile.dataset.ready || !canHover) return;
      tile.dataset.ready = '1';
      tile.addEventListener('pointerenter', () => { video.play().then(() => tile.classList.add('is-playing')).catch(() => {}); });
      tile.addEventListener('pointerleave', () => { tile.classList.remove('is-playing'); video.pause(); });
    });
  }

  /* Footer menus collapse on phones ---------------------------------------- */
  function initFooter(root) {
    root.querySelectorAll('[data-footer-accordion]').forEach((d) => d.setAttribute('open', ''));
  }

  /* Phone menu drawer ------------------------------------------------------ */
  function initDrawer(root) {
    root.querySelectorAll('[data-menu-open]').forEach((btn) => {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      const drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      const close = () => {
        drawer.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        setTimeout(() => { drawer.hidden = true; }, reduceMotion ? 0 : 350);
        btn.focus();
      };
      btn.addEventListener('click', () => {
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        btn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
        const first = drawer.querySelector('[data-menu-close].icon-button');
        if (first) first.focus();
      });
      drawer.querySelectorAll('[data-menu-close]').forEach((c) => c.addEventListener('click', close));
      drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    });
  }

  /* Launch: countdown, labels, buy buttons --------------------------------- */
  function initLaunch(root) {
    const cfg = window.inkanLaunch;
    if (!cfg || !cfg.on || !cfg.date) return;
    const parts = cfg.date.split('-').map(Number);
    const launchAt = new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1);
    if (isNaN(launchAt)) return;
    const now = new Date();
    const live = now >= launchAt;
    const days = Math.ceil((launchAt - now) / 86400000);

    root.querySelectorAll('[data-countdown]').forEach((el) => {
      el.textContent = live ? '' : days === 1 ? '1 day to go' : days + ' days to go';
    });
    root.querySelectorAll('[data-launch-note]').forEach((note) => {
      const before = note.querySelector('[data-launch-note-before]');
      const after = note.querySelector('[data-launch-note-after]');
      if (live && before && after) { before.hidden = true; after.hidden = false; }
    });
    if (live) {
      root.querySelectorAll('[data-launch-badge], [data-launch-chip]').forEach((b) => { b.textContent = cfg.liveLabel; });
    }
    root.querySelectorAll('[data-add-button][data-launch="launch"]').forEach((btn) => {
      if (!live && cfg.closeBefore) {
        btn.disabled = true;
        btn.dataset.lockedUntilLaunch = '1';
        const t = btn.querySelector('[data-add-text]');
        if (t) t.textContent = btn.dataset.beforeLabel;
      }
    });
  }

  function initAll(root) {
    initDrawer(root || document);
    initLaunch(root || document);
    initAutosubmit(root || document);
    initCarousel(root || document);
    initTiles(root || document);
    initFooter(root || document);
    root = root || document;
    initHeader(root);
    initGrid(root);
    initRecommendations(root);
    initProduct(root);
    initTabs(root);
    initWaitlist(root);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const tab = e.target.closest && e.target.closest('[role="tab"]');
    if (tab) tab.click();
  });
})();